// The frame around every page: components/layout/Header.jsx and LocalePicker.jsx
// (the footer's language and currency control is the same LocalePicker).
export const chromeL = {
  en: {
    logoutUnconfirmed: "Your account is no longer displayed, but server sign-out could not be confirmed. Check your connection before leaving a shared device.",
    secureCheckout: "Secure checkout",
    travelNav: "Travel with Toukky",
    menu: "Menu",
    locale: { open: "Language and currency", language: "Language", currency: "Currency", done: "Done" },
  },
  fr: {
    logoutUnconfirmed: "Votre compte n’est plus affiché, mais la déconnexion du serveur n’a pas pu être confirmée. Vérifiez votre connexion avant de quitter un appareil partagé.",
    secureCheckout: "Paiement sécurisé",
    travelNav: "Voyager avec Toukky",
    menu: "Menu",
    locale: { open: "Langue et devise", language: "Langue", currency: "Devise", done: "Terminé" },
  },
  es: {
    logoutUnconfirmed: "Su cuenta ya no se muestra, pero no se pudo confirmar el cierre de sesión en el servidor. Compruebe su conexión antes de dejar un dispositivo compartido.",
    secureCheckout: "Pago seguro",
    travelNav: "Viajar con Toukky",
    menu: "Menú",
    locale: { open: "Idioma y moneda", language: "Idioma", currency: "Moneda", done: "Listo" },
  },
  pt: {
    logoutUnconfirmed: "A sua conta já não é apresentada, mas não foi possível confirmar o fim da sessão no servidor. Verifique a ligação antes de deixar um dispositivo partilhado.",
    secureCheckout: "Pagamento seguro",
    travelNav: "Viajar com a Toukky",
    menu: "Menu",
    locale: { open: "Idioma e moeda", language: "Idioma", currency: "Moeda", done: "Concluído" },
  },
  ar: {
    logoutUnconfirmed: "لم يعد حسابك معروضًا، لكن تعذر تأكيد تسجيل الخروج من الخادم. تحقق من اتصالك قبل ترك جهاز مشترك.",
    secureCheckout: "دفع آمن",
    travelNav: "السفر مع Toukky",
    menu: "القائمة",
    locale: { open: "اللغة والعملة", language: "اللغة", currency: "العملة", done: "تم" },
  },
  zh: {
    logoutUnconfirmed: "您的账户已不再显示，但无法确认服务器端已退出登录。离开共用设备前，请检查网络连接。",
    secureCheckout: "安全支付",
    travelNav: "与 Toukky 一起旅行",
    menu: "菜单",
    locale: { open: "语言和货币", language: "语言", currency: "货币", done: "完成" },
  },
};
